import { z } from 'zod'
import { validateCpf } from '@/helpers'

export const nameFormSchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(1, 'Obrigatório')
    .refine(
      (value) => value.split(/\s+/).length >= 2,
      'Digite nome e sobrenome',
    ),
})

export type NameFormData = z.infer<typeof nameFormSchema>

export const cpfFormSchema = z.object({
  taxId: z
    .string()
    .trim()
    .min(1, 'Obrigatório')
    .refine((value) => validateCpf(value), 'CPF inválido'),
})

export type CpfFormData = z.infer<typeof cpfFormSchema>

export const emailFormSchema = z.object({
  email: z.string().trim().min(1, 'Obrigatório').email('E-mail inválido'),
})

export type EmailFormData = z.infer<typeof emailFormSchema>

export const signupPasswordSchema = z.object({
  password: z
    .string()
    .min(8, 'Ao menos 8 caracteres')
    .regex(/[A-ZÀ-Ý]/, 'Ao menos uma letra maiúscula')
    .regex(/\d/, 'Ao menos um número')
    .regex(/[^A-Za-zÀ-ÿ0-9]/, 'Ao menos um caractere especial'),
})

export type SignupPasswordFormData = z.infer<typeof signupPasswordSchema>

export function passwordRules(password: string) {
  return [
    ['Ao menos 8 caracteres', password.length >= 8],
    ['Ao menos uma letra maiúscula', /[A-ZÀ-Ý]/.test(password)],
    ['Ao menos um número', /\d/.test(password)],
    ['Ao menos um caractere especial (!@#$)', /[^A-Za-zÀ-ÿ0-9]/.test(password)],
  ] as const
}
